// @flow
import type {HttpService} from 'modules/common/services/http';
import type {TAddLicenseParams, TLicenseListParams} from 'modules/license/types';
import type {TResponse} from 'types';

/**
 * Сервис для загрузки информации о лицензиях
 */
export class LicenseApi {
    /**
     * Сервис для отправки HTTP запросов
     */
    _http: HttpService;

    /**
     * @param http Сервис для отправки HTTP запросов
     */
    constructor(http: HttpService) {
        this._http = http;
    }

    /**
     * Fetch запрос "Получить список лицензии"
     * @param params доп. параметры для сортировки
     * @return список всех лицензий
     */
    async getLicenseList<T>({params}: TLicenseListParams): TResponse<T> {
        return this._http.get<T>('/license', {
            extraOptions: {
                isPrivate: true,
            },
            query: {
                ...params,
            },
        });
    }

    /**
     * Fetch запрос "Активировать лицензию"
     * @param activationCode активационный ключ
     * @return статус об успешном создании новых пользователей
     */
    async activateLicenses<T>(activationCode: TAddLicenseParams): TResponse<T> {
        return this._http.post<T>('/license/activate', {
            body: activationCode,
            extraOptions: {
                isPrivate: true,
            },
            options: {
                headers: {
                    'Content-Type': 'application/json',
                    'X-http-method-override': 'POST',
                },
            },
        });
    }

    /**
     * Fetch запрос "Запросить ссылку на отчет по всем лицензиям"
     * @return ссылка на файл отчета
     */
    async reportLicenseList<T>(): TResponse<T> {
        return this._http.post<T>(`/license/report-license-list?timezoneOffset=${new Date().getTimezoneOffset()}`, {
            extraOptions: {
                isPrivate: true,
            },
        });
    }
}
